module.exports = __webpack_public_path__ + "img/stel-logo.0c6c8b60.png";